import React from 'react';
import PropTypes from 'prop-types';
import { Form, reduxForm, getFormValues } from 'redux-form';
import classNames from 'classnames';

import { connectTo } from '../../../utils';
import {
  mobileNumber as mobileValidator,
  email as emailValidator,
} from '../../../utils/validation';
import phoneTransformer from '../../../utils/phone';

import { Select, Button, TextField, Translation } from '../../common';

import {
  getBalanceWithCurrency,
  validRates,
  IDEAL_INSTALLMENT_FORM_NAME,
  EMAIL_PLACEHOLDER,
  PHONE_PLACEHOLDER,
} from '../../../constants/payment';

import ideal from '../../../assets/img/payment/ideal.gif';

const selectFieldInit = (number) => {
  const arr = [];
  for (let i = 0; i < number; i++) {
    arr.push({
      label: `${i + 1}`,
      value: i + 1,
      id: `page.payments.component.ideal-installment.day-select-${i + 1}-item`,
    });
  }
  return arr;
};

const installmentsInit = (currency, validRates) => {
  const result = [];

  for (let i = 0; i < validRates.length; i++) {
    result.push({
      label: `${
        currency
          ? getBalanceWithCurrency(validRates[i], currency)
          : validRates[i]
      }`,
      value: validRates[i],
      id: `page.payments.component.ideal-installment.amount-select-${validRates[i]}-item`,
    });
  }

  return result;
};

const mobilePhoneCheck = (phone) => {
  return mobileValidator()(phone);
};

const selectFieldOptions = selectFieldInit(31);

const IDEALInstallment = ({
  currency,
  styles,
  handleSubmit,
  onSubmit,
  validRates,
  className,
  values,
  invalid,
}) => {
  const installmentsOptions = installmentsInit(currency, validRates);

  return (
    <Form
      className={classNames(styles['ideal-installment__form'], className)}
      onSubmit={handleSubmit(({ mobilePhone, ...values }) =>
        onSubmit({
          ...values,
          mobilePhone:
            (mobilePhone && phoneTransformer(mobilePhone)[0]) || null,
        })
      )}
    >
      <div className={styles['ideal-installment__row']}>
        <Translation className={styles['ideal-installment__label']}>
          PAYMENT_INSTALLMENT_AMOUNT_LEFT
        </Translation>
        <div className={styles['ideal-installment__select-wrapper']}>
          <Select
            className={styles['ideal-installment__select']}
            classNameInput={styles['ideal-installment__select-input']}
            classNameRoot={styles['ideal-installment__select-root']}
            name="amount"
            options={installmentsOptions}
          />
          <Translation className={styles['ideal-installment__past-label']}>
            PAYMENT_INSTALLMENT_AMOUNT_RIGHT
          </Translation>
        </div>
      </div>

      <Translation
        className={classNames(
          styles['ideal-installment__row'],
          styles['ideal-installment__input-description']
        )}
      >
        PAYMENT_INSTALLMENT_AMOUNT_BENEATH
      </Translation>

      <div className={styles['ideal-installment__row']}>
        <Translation className={styles['ideal-installment__label']}>
          PAYMENT_INSTALLMENT_CALENDER_LEFT
        </Translation>
        <div className={styles['ideal-installment__select-wrapper']}>
          <Select
            className={styles['ideal-installment__select']}
            classNameInput={styles['ideal-installment__select-input']}
            classNameRoot={styles['ideal-installment__select-root']}
            name="day"
            options={selectFieldOptions}
          />
          <Translation className={styles['ideal-installment__past-label']}>
            PAYMENT_INSTALLMENT_CALENDER_RIGHT
          </Translation>
        </div>
      </div>

      <Translation
        className={classNames(
          styles['ideal-installment__row'],
          styles['ideal-installment__input-description']
        )}
      >
        PAYMENT_INSTALLMENT_CALENDER_BENEATH
      </Translation>

      <div className={styles['ideal-installment__row']}>
        <Translation className={styles['ideal-installment__label']}>
          PAYMENT_EMAILADDRESS_LEFT
        </Translation>
        <div className={styles['ideal-installment__input-with-description']}>
          <TextField
            name="email"
            placeholder={EMAIL_PLACEHOLDER}
            className={styles['ideal-installment__input-wrapper']}
            classNameInput={
              styles[
                !values.email || !emailValidator(values.email)
                  ? 'ideal-installment__input-field'
                  : 'ideal-installment__input-field_red'
              ]
            }
            classNameRoot={styles['ideal-installment__input-root']}
            validate={emailValidator}
          />
          <Translation
            className={styles['ideal-installment__input-description']}
          >
            PAYMENT_EMAILADDRESS_BENEATH
          </Translation>
        </div>
      </div>

      <div className={styles['ideal-installment__row']}>
        <Translation className={styles['ideal-installment__label']}>
          PAYMENT_MOBILENUMBER_LEFT
        </Translation>
        <div className={styles['ideal-installment__input-with-description']}>
          <TextField
            name="mobilePhone"
            placeholder={PHONE_PLACEHOLDER}
            className={styles['ideal-installment__input-wrapper']}
            classNameInput={
              styles[
                !values.mobilePhone || !mobilePhoneCheck(values.mobilePhone)
                  ? 'ideal-installment__input-field'
                  : 'ideal-installment__input-field_red'
              ]
            }
            classNameRoot={styles['ideal-installment__input-root']}
            validate={mobilePhoneCheck}
          />
          <Translation
            className={styles['ideal-installment__input-description']}
          >
            PAYMENT_MOBILENUMBER_BENEATH
          </Translation>
        </div>
      </div>

      <Button
        id="page.payments.component.ideal-installment.button"
        className={styles['ideal-installment__button']}
        type="submit"
        disabled={invalid}
      >
        <img
          src={ideal}
          className={styles['ideal-installment__button-image']}
          alt="ideal"
        />
        <Translation>PAYMENT_INSTALLMENT_BUTTON</Translation>
      </Button>
    </Form>
  );
};

IDEALInstallment.propTypes = {
  onSelectChange: PropTypes.func,
  picture: PropTypes.string,
  form: PropTypes.any,
  onSubmit: PropTypes.func,
};

const ConnectedForm = reduxForm({
  form: IDEAL_INSTALLMENT_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(
  connectTo(
    (state) => ({
      values: getFormValues(IDEAL_INSTALLMENT_FORM_NAME)(state),
    }),
    {},
    IDEALInstallment
  )
);

export default ({
  currency,
  balance,
  onSubmit,
  className,
  email,
  mobilePhone,
  phone,
  styles,
}) => {
  const validRatesArr = validRates(balance);
  const initialValues = {
    amount: validRatesArr[0],
    day: 1,
    email: email,
    mobilePhone: mobilePhone || phone,
  };
  return (
    <ConnectedForm
      {...{
        currency,
        onSubmit,
        initialValues,
        validRates: validRatesArr,
        className,
        styles,
      }}
    />
  );
};
